import { format } from 'date-fns';

import { AdminEventUsersQuery, User } from '../../apollo/__generated__/graphql';
import { isDateString } from '../../services/date';

type DownloadableUser = AdminEventUsersQuery['eventUsers'][0] | User;

const downloadCSV = (filename: string, text: string) => {
  const csvContent = 'data:text/csv;charset=utf-8,' + encodeURIComponent(text);
  const link = document.createElement('a');
  link.href = csvContent;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const translatedKeys: Record<keyof DownloadableUser, string> = {
  id: 'ID',
  firstname: 'Prénom',
  lastname: 'Nom',
  nickname: 'Surnom',
  email: 'Email',
  phone: 'Téléphone',
  studyTown: 'Ville',
  studies: 'Études',
  hasCaution: 'Caution',
  hasPaidTicket: 'À payé',
  paidTicketAt: 'Date de paiement',
  hasPaidBedroom: 'Chambre payée',
  paidBedroomAt: 'Date de paiement de la chambre',
  isNoAlcool: 'Sans alcool',
  isValidated: 'Est validé',
  userComment: 'Commentaire utilisateur',
  orgaComment: 'Commentaire orga',
  __typename: 'Type',
  allergies: 'Allergies',
  birthdate: 'Date de naissance',
  externalReferentFirstname: 'Prénom du référent',
  externalReferentLastname: 'Nom du référent',
  externalReferentPhone: 'Téléphone du référent',
  folklore: 'Folklore',
  food: 'Alimentation',
  medication: 'Médicaments',
  joinedAt: "Date d'inscription",
  waitingListPosition: "Position sur la liste d'attente",
  pastEvents: 'Événements passés',
  arrivalDay: "Jour d'arrivée (0 = vendredi / 1 = samedi / -1 = pas d'arrivée)",
  numberOfDays: 'Nombre de jours payé',
  maxSuperLikes: 'Super likes',
};

const formatUsersAsCsv = (users: DownloadableUser[]) => {
  if (users.length === 0) {
    return '';
  }
  const usersAsCsv = users
    .map((user) => {
      return Object.entries(user)
        .map(([key, value]) => {
          if (key === 'pastEvents') {
            return (value as User['pastEvents'])
              .map((event) => event.name)
              .join(' ');
          }
          if (typeof value === 'string') {
            if (isDateString(value)) {
              return format(value, 'dd/MM/yyyy HH:mm:ss');
            }
            return value.replaceAll('\n', '').replaceAll(',', ';');
          }
          return value;
        })
        .join(',');
    })
    .join('\n');

  const user = users[0];

  const csvHeader = Object.keys(user)
    // @ts-expect-error Object keys are of type string
    .map((key: keyof DownloadableUser) => {
      return `${translatedKeys[key] ?? key}`;
    })
    .join(',');

  return `${csvHeader}\n${usersAsCsv}`;
};

export const downloadUsersAsCsv = (users: DownloadableUser[]) => {
  const csvData = formatUsersAsCsv(users);
  downloadCSV('users.csv', csvData);
};
